import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material"
import { useState } from "react"
import { Helmet } from "react-helmet"

import './about.css'
import { FadeInSection } from "./home_window"
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const AboutUs = ({about_info=[]}) => {
    
    return (
        <div>
            <div className="landing_images_3 landing_center" id="site_cover_image">
                <Helmet>
                    <title>DGA | Packages</title>
                </Helmet>
                <div className="company_details">
                    <div className="company_name smaller_company_name" id="company_name">
                        WHO WE ARE
                    </div>
                    <div className="tag_line">
                        ABOUT DGA
                    </div>
                </div>
                <div className="navigation_on_home_container">
                </div> 
            </div>

            <div className="packages_main middle_component" style={{marginTop:'0px'}}>
				<div className="packs_window">
                    <div>
                        {about_info.length > 0 && 
                        about_info.map(info => (
                            <FadeInSection>
                                <div key={info.id} className='about_container' > 
                                    <AboutQsn q={info} />
                                </div>
                            </FadeInSection>
                        ))
                        }
                    </div>
				</div>
			</div>
        </div>
    )
}


const AboutQsnV1 = ({info}) => {

    const [showAbout, setShowAbout] = useState(false)

    return (
        <div style={{width:'100%'}}>
            <div className="about_qsn flex_row_about" onClick={e=> setShowAbout(!showAbout)}>
                    <div>
                        {info.title}
                    </div>
                    <div>
                        {showAbout? <KeyboardArrowDown />:<KeyboardArrowUp />}
                        </div>
                    </div>
                <div className={`about_ans ${!showAbout? '':'hidden_about'}`}>
                    {info.text}
            </div>
        </div>
    )
}


export function AboutQsn({q}) {
    const [expanded, setExpanded] = useState(false);
  
    const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };
  
    return (
      <div style={{marginTop:'15px'}}>
        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography sx={{ width: '33%', flexShrink: 0 }}>
              {q.category}
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>{q.title}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              {q.text}
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    );
  }
